import gql from "graphql-tag"

const GetVendorList = gql`
  query GetVendorList($search: String, $starting_after: String) {
    vendors(search: $search, starting_after: $starting_after) {
      id
      name
      slug
    }
  }
`

export { GetVendorList }
